import React, { Component } from 'react';
import PropTypes from 'prop-types';


import classes from './TPTransformerVoltageSelector.css';
import FourOptionsSelector from '../../../../UI/Selectors/FourOptionsSelector/FourOptionsSelector';
import TransformerTable from '../../../TransformerTable/TransformerTable';

class TPTransformerVoltageSelector extends Component {
  state = {
    selectedVoltage: '208V'
  };

  handleOption1Selection = () => {
    this.setState({
      selectedVoltage: '208V'
    });
  };

  handleOption2Selection = () => {
    this.setState({
      selectedVoltage: '240V'
    });
  };

  handleOption3Selection = () => {
    this.setState({
      selectedVoltage: '480V'
    });
  };

  handleOption4Selection = () => {
    this.setState({
      selectedVoltage: '600V'
    });
  };

  render() {
    const { selectedVoltage } = this.state;
    const { country, language } = this.props;
    return (
      <div className={classes.TPTransformerVTComponent}>
        <FourOptionsSelector
          selectedOption={selectedVoltage}
          option1="208V"
          option2="240V"
          option3="480V"
          option4="600V"
          selectedOption1={this.handleOption1Selection}
          selectedOption2={this.handleOption2Selection}
          selectedOption3={this.handleOption3Selection}
          selectedOption4={this.handleOption4Selection}
        />
        <TransformerTable
          phase="three"
          voltage={selectedVoltage}
          country={country}
          language={language}
        />
      </div>
    );
  }
}

TPTransformerVoltageSelector.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
};

export default TPTransformerVoltageSelector;
